import getTimeZoneOperation from 'owa-service/lib/operation/getTimeZoneOperation';
import TimeZoneEntry from 'owa-service/lib/contract/TimeZoneEntry';

export default function getTimeZone(): Promise<TimeZoneEntry[]> {
    try {
        return getTimeZoneOperation({
            needTimeZoneList: true,
        }).then(response => response && response.TimeZoneList);
    } catch {
        return Promise.resolve(null);
        // Error handling with reject will be done later
        // https://outlookweb.visualstudio.com/Outlook%20Web/Outlook%20Web%20Team/_workitems/edit/33663
    }
}
